import { toast } from "sonner";

/**
 * The one save-failure message for the Settings notification surfaces.
 *
 * Background (issue #431 follow-up): every one of those controls updates its
 * local state optimistically so the tap feels instant, then writes to Supabase.
 * When the write lost, the optimistic state stood while the database disagreed —
 * she saw a toggle in a state that was never saved, and nothing said so.
 *
 * The rule now is: failure reverts the control AND says so, once. This lives in
 * one place so all four write paths say exactly the same thing, and so the tests
 * can assert on the string rather than a copy of it.
 *
 * Not a new toast mechanism — a thin wrapper over the app's existing sonner
 * toast, same as every other user-facing message in the app.
 */
export const SAVE_FAILED_MESSAGE = "Hmm, that didn't save — mind trying again? 💜";

export function showSaveFailedToast() {
  toast.error(SAVE_FAILED_MESSAGE);
}
